import React__default, { createContext, useContext, useState } from "react";
import { Hidden as T, HiddenFeatures as s } from "../internal/hidden.js";
import { getOwnerDocument as u } from "../utils/owner.js";
import { useEvent as o } from "./use-event.js";
import { useOwnerDocument as n } from "./use-owner.js";
function R({ defaultContainers: l = [], portals: n$1, mainTreeNode: o$1 } = {}) {
  let r = n(o$1), u2 = o(() => {
    var i, c;
    let t = [];
    for (let e of l) e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
    if (n$1 != null && n$1.current) for (let e of n$1.current) t.push(e);
    for (let e of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : []) e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o$1 && (e.contains(o$1) || e.contains((c = o$1 == null ? void 0 : o$1.getRootNode()) == null ? void 0 : c.host)) || t.some((m) => e.contains(m)) || t.push(e));
    return t;
  });
  return { resolveContainers: u2, contains: o((t) => u2().some((i) => i.contains(t))) };
}
let a = createContext(null);
function O({ children: l, node: n2 }) {
  let [o2, r] = useState(null), u$1 = b(n2 != null ? n2 : o2);
  return React__default.createElement(a.Provider, { value: u$1 }, l, u$1 === null && React__default.createElement(T, { features: s.Hidden, ref: (t) => {
    var i, c;
    if (t) {
      for (let e of (c = (i = u(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : []) if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
        r(e);
        break;
      }
    }
  } }));
}
function b(l = null) {
  var n2;
  return (n2 = useContext(a)) != null ? n2 : l;
}
export {
  O as MainTreeProvider,
  b as useMainTreeNode,
  R as useRootContainers
};
